import {svgIconWrapper} from '../svg-icon-wrapper';

import WhatsAppRegular from './whatsapp-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <WhatsAppRegular {...props} />;
}

SvgComponent.iconName = 'whatsAppRegular';

export const WhatsAppRegularIcon = svgIconWrapper(SvgComponent);
